module.exports = "/315f00b266322457632a73db87dec70e.png";